import React from 'react';
import { useSelector } from 'react-redux';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import ModernizedNotes from 'src/components/Notes/ModernizedNotes';
import { UseNotesAPIReturn } from 'src/SharedCustomHooks/UseNotesAPI/useNotesAPI';

interface ItemNotesProps {
  notesAPI: UseNotesAPIReturn;
  entityId: string;
  afterMutate?: () => void;
}

const HIDDEN_ADD_ROLES: string[] = [
  'Strata Manager',
  'Vendor',
  'Home Owner',
  'Realtor',
  'Occupant',
];

const ItemNotes = ({ notesAPI, entityId, afterMutate }: ItemNotesProps) => {
  const user: any = useSelector(selectAuthenticatedUser);
  const prLoader: any = useSelector(selectPRLoader);

  const userRole: string = user?.roles?.[0]?.role?.name || '';
  const canAddNotes: boolean = !HIDDEN_ADD_ROLES.includes(userRole);

  const isLoading: boolean =
    prLoader || (notesAPI.loadingNotes && notesAPI.notes.length === 0);

  return (
    <ModernizedNotes
      notesAPI={notesAPI}
      entityId={entityId}
      itemType="Item"
      userId={user.id}
      canAddNote={canAddNotes}
      canDelete={true}
      loading={isLoading}
      afterMutate={afterMutate}
      addDialogTitle="Add Item Note"
      editDialogTitle="Edit Item Note"
      addDialogDescription="Add a private or resident-visible note for this item."
    />
  );
};

export default ItemNotes;
